module.exports = "/src/views/player/help/images/burger2.jpg";